module.exports = __webpack_public_path__ + "img/sankaku_63_red.dcdce2cc.png";